/**
 * Query keys for user PHR data.
 */
export const userPhrKeys = {
  all: ['user-phr'] as const,
  byUser: (userId: string) => ['user', userId, 'phr'] as const,
};
